import store from "@frameworks/web/redux/store";
import { IPOCANCEL_DATA, IPOCANCEL_ERROR_DATA, IPOCANCEL_HIDE_ERROR_DATA, IPOCANCEL_START_LOADER, IPOCANCEL_STOP_LOADER, } from "../interface/IpoCancel";
class IpoCancelActiton {
    constructor() {
        this.dispatch = store.dispatch;
    }
    getIpoCancel(IpoCancel) {
        this.dispatch({
            type: IPOCANCEL_DATA,
            payload: { data: IpoCancel },
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: IPOCANCEL_ERROR_DATA,
            payload: { errorData: payload },
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: IPOCANCEL_HIDE_ERROR_DATA,
        });
    }
    startLoader() {
        this.dispatch({
            type: IPOCANCEL_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: IPOCANCEL_STOP_LOADER,
        });
    }
}
export default IpoCancelActiton;
